import { useState } from 'react';
import {
  Button,
  Text,
  Flex,
  Divider,
  Alert,
  AlertIcon,
} from '@chakra-ui/react';
import { useBilling } from '../../../store/client/BillingContext';
import { paymentMethodLabel } from '../../../utils/paymentMethodLabel';

const UpdatePlanModal = ({
  handleClose,
  onSuccess,
  selectedPlan,
  cancelPlan,
  handleSubscribe,
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { paymentMethod } = useBilling();

  const billingPriceText = selectedPlan?.price ?? '';

  const handleUpdatePlan = async () => {
    setLoading(true);
    setError(null);

    const planId = selectedPlan?.planId;
    const priceId = selectedPlan?.priceId;

    if (!planId) {
      setError('Missing required plan ID');
      setLoading(false);
      return;
    }

    if (!priceId) {
      setError('Missing required price ID');
      setLoading(false);
      return;
    }

    if (handleSubscribe) {
      try {
        await handleSubscribe();
        onSuccess();
      } catch (error) {
        console.error(error);
      }
    }
  };

  const isYearly = selectedPlan?.interval === 'year';

  return (
    <Flex direction="column" w="full" px={6} pt={6}>
      <Text textStyle="heading3" textAlign="center">
        Confirm plan upgrade
      </Text>
      <Divider border="1px solid" borderColor="lightGrey" mt="10px" />
      {!cancelPlan && (
        <>
          <Flex direction="column" px={6} mt={6}>
            <Text textstyle="bodyLarge" fontSize="16px">
              Are you sure you want to upgrade your plan to{' '}
              <b>{selectedPlan.label} plan</b> (billed{' '}
              {isYearly ? 'annually' : 'monthly'})?
            </Text>
            <Text textStyle="bodyLarge" mt={2} fontSize="16px">
              Your {paymentMethodLabel(paymentMethod)} will be charged
              immediately for the current billing cycle, and a recurring charge
              of <b>{billingPriceText}</b>
              {isYearly
                ? ' per year will apply on each renewal.'
                : ' per month will apply on each billing cycle.'}
            </Text>
          </Flex>
          {error && (
            <Flex px={6} mt={6}>
              <Alert status="error" borderRadius="5px">
                <AlertIcon />
                {error}
              </Alert>
            </Flex>
          )}
        </>
      )}
      <Flex direction="column" w="full" gap={4} mt="30px">
        <Button
          data-testid="confirm-update-plan-button"
          onClick={handleUpdatePlan}
          isLoading={loading}
          loadingText="Processing"
          w="100%"
        >
          {cancelPlan ? 'Cancel Plan' : 'Confirm'}
        </Button>
        <Button variant="link" onClick={handleClose} w="100%">
          <Text textStyle="bodySmall">Cancel</Text>
        </Button>
      </Flex>
    </Flex>
  );
};

export default UpdatePlanModal;
